import axios2 from 'axios';
import store from '@/reducers';
import { message } from 'antd';

const axios = axios2.create({
  baseURL: import.meta.env.VITE_PROXY,
});

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    const uid = store.getState().users.uid;

    if (config.method === 'get') {
      if (uid) {
        if (config.params) {
          if (
            typeof config.params === 'object' &&
            !Array.isArray(config.params)
          ) {
            config.params.user_id = uid;
          }
        } else {
          config.params = { user_id: uid };
        }
      }
    }

    if (
      config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'patch'
    ) {
      if (uid) {
        if (config.data) {
          if (config.data instanceof FormData) {
            config.data.append('user_id', uid);
          } else if (
            typeof config.data === 'object' &&
            !Array.isArray(config.data)
          ) {
            // 如果 data 是一个对象，添加 user_id 参数
            config.data.user_id = uid;
          }
        } else {
          // 如果 data 为空，创建一个包含 user_id 的对象
          config.data = { user_id: uid };
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    // 记录API调用日志的接口白名单
    const LOG_URLS = [
      '/api/sketchToImage',
      '/api/detectFace',
      '/api/evaluation',
      '/api/onnx/upload',
      'api/createRecTask',
      '/api/describeTaskStatus',
      '/api/textToImage_model',
      '/api/handwritingOCR',
      '/api/volc_repair',
      '/api/volc_enhance',
      '/api/volc_px',
      '/api/volc_t2v_submit',
      '/api/volc_t2v_get_result',
    ];

    // 检查是否需要记录日志
    if (LOG_URLS.some((url) => response.config.url.includes(url))) {
      // 直接发送API调用日志，不使用React Hook
      const logData = {
        user_id: store.getState().users.uid,
        type: 1, // API调用成功
        api_url: response.config.url,
        method: response.config.method,
        timestamp: new Date().toISOString(),
        path: window.location.pathname,
      };

      // 直接发送日志
      const { VITE_BASENAME, VITE_ORIGIN } = import.meta.env;
      const baseUrl = VITE_ORIGIN + VITE_BASENAME;
      fetch(`${baseUrl}/api/log/experience`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(logData),
      }).catch((error) => {
        console.error('API调用日志发送失败:', error);
      });
    }

    return response.data;
  },
  (error) => {
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error('响应错误:', error.response.status, error.response.data);
      message.error(`响应错误: ${error.response.status}`);
      switch (error.response.status) {
        case 400:
          console.log('错误的请求');
          message.error('错误的请求');
          break;
        case 401:
          console.log('未授权，请登录');
          message.error('未授权，请登录');
          break;
        case 403:
          console.log('禁止访问');
          message.error('禁止访问');
          break;
        case 404:
          console.log('请求的资源不存在');
          message.error('请求的资源不存在');
          break;
        case 500:
          console.log('服务器内部错误');
          message.error('服务器内部错误');
          break;
        default:
          console.log('未知错误');
          message.error('未知错误');
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('请求错误，没有收到响应:', error.request);
      // message.error('请求错误，没有收到响应:', error.request);
    } else {
      // 在设置请求时发生了一些事情，触发了错误
      console.error('请求设置错误:', error.message);
      // message.error('请求设置错误:', error.message);
    }
    return Promise.reject(error);
  },
);
export default axios;
